import React from 'react';
import PropTypes from 'prop-types';

import PriceChanges from 'components/priceChanges';

import { formatCurrency } from './MarketCharts.helpers';
import {
  productSummary,
  productName,
  productPrice,
} from './scss/MarketCharts.module.scss';

const MarketChartsProductSummary = ({ product }) => {
  if (!product) {
    return null;
  }

  return (
    <div className={productSummary}>
      <span className={productName}>{product.commodity}</span>
      <div className={productPrice}>
        <span>{formatCurrency(product.marketPrice)}</span>
        <PriceChanges changes={product.changePercentage} />
      </div>
    </div>
  );
};

MarketChartsProductSummary.propTypes = {
  product: PropTypes.shape({}),
};

MarketChartsProductSummary.defaultProps = {
  product: null,
};

export default MarketChartsProductSummary;
